const ne = {
  // Navbar
  nav_home: "गृहपृष्ठ",
  nav_about: "टेन्टेन अंकलको बारेमा",
  nav_services: "सेवा र मूल्य",
  nav_flow: "प्रक्रिया",
  nav_testimonials: "प्रशंसापत्र",
  nav_faq: "सामान्य प्रश्नहरू",
  nav_contact: "सम्पर्क",
  nav_cta: "नाम परामर्श बुक गर्नुहोस्",
  nav_subtitle: "नाम परामर्श · ओकिनावा",
  nav_title: "टेन्टेन अंकलको कार्यालय",

  // Hero
  hero_headline1: "ओकिनावाको टापुको",
  hero_headline2: "शान्त वातावरणमा",
  hero_headline3: "हामी सुन्छौं",
  hero_headline4: "तपाईंको नामको आवाज",
  hero_body: "परामर्शको तालिका प्रायः महिनौं अगाडि नै भरिन्छ\nप्रत्येक महिना म व्यक्तिगत रूपमा ओकिनावाको टापुमा जान्छु\nगुरुजीलाई तपाईंको नाम पुर्‍याउन",
  hero_pill1: "नाम परिवर्तन गर्नु पर्दैन",
  hero_pill2: "१००% अनलाइन",
  hero_pill3: "१ महिनाभित्र परिणाम",
  hero_pill4: "प्रति महिना १०० स्थान",
  hero_btn_apply: "नाम परामर्श बुक गर्नुहोस्",
  hero_btn_services: "सेवाहरू हेर्नुहोस्",
  hero_scroll: "तल स्क्रोल गर्नुहोस्",

  // About
  about_heading: "टेन्टेन अंकलको बारेमा",
  about_intro: "ओकिनावाको न्यानो समुद्रको बीचमा शान्त <strong>इकेई टापु</strong>मा\nप्रत्येक नामको लागि सानो ज्योति जलाउने एक व्यक्ति छन्\nमानिसहरूले उनलाई प्यारले <strong>\"टेन्टेन अंकल\"</strong> भन्छन्",
  about_block1_label: "बैंक कर्मचारीबाट नाम विशेषज्ञसम्म",
  about_block1_text: "टेन्टेन अंकल पहिले बैंक कर्मचारी थिए\nआफ्नो परिश्रमले उनी कम्पनीमा <strong>सबैभन्दा कम उमेरका शाखा प्रबन्धक</strong> बने\nमानिसहरूसँग धेरै भेटघाटमा, उनको मनमा एउटा प्रश्न उठ्यो",
  about_block1_quote: "\"किन केही मानिसहरू समान प्रयास गर्दा पनि अगाडि बढ्ने हावा पाउँछन्?\"",
  about_block1_sub: "त्यो सानो प्रश्न एउटा ठूलो खोजको सुरुवात भयो",
  about_block2_label: "प्राचीन ज्ञान र शान्तिको प्रकाश",
  about_block2_text: "उनले आफ्नो सबै खाली समय नाम परामर्शसम्बन्धी प्राचीन पुस्तकहरू अध्ययन गर्न लगाए, परम्परागत कान्जी र ध्वनि प्रवाहलाई ध्यानपूर्वक अध्ययन गरे",
  about_block2_text2: "उनले पत्ता लगाए कि <strong>\"टेन्टेन चिह्नले नामको प्रवाहलाई कोमलतापूर्वक मिलाउन सक्छ\"</strong>",
  about_block2_sub: "यो नाटकीय जादू होइन, यो सफलताको अद्भुत सूत्र होइन\nबरु एउटा कोमल मार्ग जसले तपाईंभित्रको प्रकाशलाई अझ उज्यालो बनाउन मद्दत गर्छ",
  about_block3_label: "मुखबाट मुखमा — ६ महिना पर्खाइ",
  about_block3_text: "उनको परामर्श शैलीको न्यानोपन मुखबाट मुखमा फैलियो, र अहिले <strong>सबै कुनाबाट निरन्तर प्रश्नहरू आइरहन्छन्</strong>\nउनी सबैलाई समान हृदयले व्यवहार गर्छन्, चाहे प्रसिद्ध होस् वा नहोस्\nप्रत्येक नाममा हात राखेर प्रत्येकको जीवनसँग साथ दिन्छन्\nयही हो टेन्टेन अंकलको तरिका",

  // Gallery
  gallery_heading: "फोटो ग्यालेरी",
  gallery_sub: "ओकिनावा · इकेई टापु",

  // Services
  services_heading: "सेवा र मूल्य",
  services_note1: "※ सबै प्याकेजमा गुरुजीको परामर्श शुल्क र प्रतिनिधित्व शुल्क समावेश छ",
  services_note2: "※ कुनै अतिरिक्त शुल्क छैन, निश्चिन्त हुनुहोस्",
  services_tab1: "व्यक्तिगत नाम",
  services_tab2: "व्यापार नाम",
  services_tab3: "पाल्तु जनावरको नाम",
  services_tab1_en: "Personal Name",
  services_tab2_en: "Business Name",
  services_tab3_en: "Pet Name",
  services_tab1_desc: "तपाईंको विकास, वातावरण र आत्माको गतिलाई कोमलतापूर्वक विचार गरेर, सबैभन्दा उपयुक्त टेन्टेन चिह्न थप्छौं",
  services_tab2_desc: "नयाँ चुनौतीको लागि ताजा हावा ल्याउँदै, तपाईंको व्यापारको प्रवाहलाई कोमलतापूर्वक मिलाउँछौं",
  services_tab3_desc: "सधैं तपाईंसँग रहने परिवारको सदस्यको लागि, शान्ति र न्यानोपनले भरिएको नाम दिनुहोस्",
  services_row1_target1: "१६ वर्ष र माथि",
  services_row1_target2: "४-१५ वर्ष",
  services_row1_target3: "०-३ वर्ष",
  services_row2_target1: "ब्रान्ड / कम्पनी / पसलको नाम",
  services_row3_target1: "पाल्तु जनावरको नाम",
  services_col_target: "लक्ष्य",
  services_col_price: "मूल्य (कर सहित)",
  services_cta: "यो सेवा बुक गर्नुहोस्",
  services_includes_title: "मूल्यमा समावेश (सबै)",
  services_inc1: "नाम परामर्श",
  services_inc2: "सर्वोत्तम टेन्टेन चिह्न सुझाव",
  services_inc3: "बिजनेस कार्ड साइजको कार्ड पठाउने (इच्छाअनुसार निःशुल्क)",
  services_inc4: "भाग्य सल्लाह",
  services_inc5: "नाम कार्डको डिजिटल छवि",
  services_includes_note: "परामर्शको उद्देश्य तपाईंको नाममा पहिलेदेखि रहेको जादूलाई कोमलतापूर्वक जगाउनु हो",
  services_payment_title: "भुक्तानी विधि",
  services_payment_method: "बैंक ट्रान्सफर (अग्रिम भुक्तानी)",
  services_payment_desc: "दर्ता गरेपछि, हामी बैंक खाताको जानकारी प्रदान गर्नेछौं\nभुक्तानी पूरा भएपछि, भाग्यको प्रवाह शान्तरूपमा जम्मा हुन थाल्छ",
  services_first_title: "पहिलो पटकको लागि",
  services_first_desc: "हिचकिचाहटको भावना सामान्य हो\nत्यो भावना भित्रबाट एउटा संकेत हो\nकि कोमल परिवर्तन सुरु गर्ने समय आएको छ",
  services_first_cta: "परामर्शबाट सुरु गर्नुहोस्",

  // Flow
  flow_heading: "सेवाको प्रक्रिया",
  flow_step1_title: "फर्म पठाउनुहोस्",
  flow_step1_c1: "विशेष फर्ममा आवश्यक जानकारी भर्नुहोस्",
  flow_step1_c2: "पठाएको २-३ कार्य दिनभित्र हामी जवाफ दिनेछौं",
  flow_step1_c3: "इमेलमा अर्को चरणहरू र ट्रान्सफर निर्देशनहरू हुनेछन्",
  flow_step2_title: "परामर्श शुल्क ट्रान्सफर गर्नुहोस्",
  flow_step2_c1: "जवाफ इमेलमा उल्लेख गरिएको खातामा परामर्श शुल्क ट्रान्सफर गर्नुहोस्",
  flow_step2_c2: "भुक्तानी पुष्टि भएपछि, हामी क्रमअनुसार तयारी सुरु गर्नेछौं",
  flow_step3_title: "ट्रान्सफर पुष्टि",
  flow_step3_c1: "ट्रान्सफर गरेपछि, इमेलमा उल्लेख गरिएको ठेगानामा रसिदको फोटो पठाउनुहोस्",
  flow_step3_c2: "पुष्टि भएपछि, हामी \"दर्ता पूरा भयो\" सन्देश पठाउनेछौं",
  flow_step3_note: "यो पुष्टि नभएसम्म हामी परामर्श सुरु गर्न सक्दैनौं। पठाउन नबिर्सनुहोस्",
  flow_step4_title: "परामर्श परिणाम प्राप्त गर्नुहोस्",
  flow_step4_c1: "परामर्श पूरा भएपछि, एक हप्ताभित्र इमेलमार्फत नाम कार्डको फोटो र टेन्टेन चिह्न पठाउनेछौं",
  flow_step4_c2: "त्यसपछि विस्तृत परामर्श रिपोर्ट र भाग्य सल्लाह इमेलमार्फत पठाउनेछौं",
  flow_step5_title: "नाम कार्ड पठाउने (ऐच्छिक)",
  flow_step5_c1: "इच्छाअनुसार, गुरुजीले लेखेको बिजनेस कार्ड साइजको कार्ड हुलाकमार्फत पठाउनेछौं",
  flow_step5_c2: "फर्मको ठेगाना स्तम्भमा सही हुलाक ठेगाना भर्नुहोस्",
  flow_step5_note: "कार्ड आवश्यक नभएमा, तपाईं बस्ने शहरको नाम मात्र भर्नुहोस्",
  flow_banner_title: "सबै अनलाइन, जापानको जहाँबाट पनि",
  flow_banner_desc: "ओकिनावाको इकेई टापुमा व्यक्तिगत रूपमा जानु पर्दैन\nदैनिक दिनचर्या नबदलीकन तुरुन्त सुरु गर्न सकिन्छ",
  flow_banner_cta: "अहिले दर्ता गर्नुहोस्",

  // Testimonials
  testimonials_heading: "ग्राहकहरूको प्रशंसापत्र",
  testimonials_viewing: "हाल हेर्दै",

  // FAQ
  faq_heading: "सामान्य प्रश्नहरू",
  faq_cta_title: "अरू प्रश्नहरू छन्?",
  faq_cta_desc: "सानातिना प्रश्नहरू पनि हामी खुसीसाथ स्वागत गर्छौं\nसोध्न लाज लाग्ने प्रश्न — त्यही हामी सबैभन्दा बढी सुन्न चाहन्छौं",
  faq_cta_btn: "प्रश्न सोध्नुहोस्",

  // CTA Banner
  cta_heading1: "निःशुल्क",
  cta_heading2: "परामर्श",
  cta_btn: "अहिले बुक गर्नुहोस्",

  // Contact
  contact_heading: "सम्पर्क",
  contact_desc: "यो फर्ममार्फत नाम परामर्शको अनुरोध वा प्रश्न पठाउनुहोस्। हामी सामान्यतः २-३ कार्य दिनभित्र जवाफ दिन्छौं",
  contact_address_label: "ठेगाना",
  contact_address_value: "तोचिगी, जापान (अनलाइन · सम्पूर्ण देशमा सेवा)",
  contact_email_label: "इमेल",
  contact_hours_label: "कार्य समय",
  contact_hours_value: "सोम–शुक्र ९:००–१८:०० (शनि/आइत/सार्वजनिक बिदा बन्द)",
  contact_note_title: "जवाफको बारेमा",
  contact_note_desc: "जवाफ स्प्याम फोल्डरमा जान सक्छ\n२-३ कार्य दिनभित्र जवाफ नआएमा, कृपया इमेलमार्फत सिधै सम्पर्क गर्नुहोस्",
  contact_field_name: "पूरा नाम",
  contact_field_furigana: "फुरिगाना (नाम पढ्ने तरिका)",
  contact_field_email: "इमेल ठेगाना",
  contact_field_phone: "फोन नम्बर",
  contact_field_service: "चाहिएको सेवा",
  contact_field_message: "सन्देश",
  contact_placeholder_name: "राम बहादुर श्रेष्ठ",
  contact_placeholder_furigana: "ヤマダ タロウ",
  contact_placeholder_email: "example@mail.com",
  contact_placeholder_phone: "+977 000 000 0000",
  contact_placeholder_message: "परामर्श गर्न चाहेको नाम वा तपाईंका प्रश्न र अनुरोधहरू यहाँ लेख्नुहोस्",
  contact_select_placeholder: "छान्नुहोस्",
  contact_service1: "व्यक्तिगत नाम",
  contact_service2: "व्यापार नाम",
  contact_service3: "पाल्तु जनावरको नाम",
  contact_service4: "अन्य / थप सोध्नुहोस्",
  contact_submit: "पठाउनुहोस्",
  contact_submitting: "पठाउँदै...",
  contact_privacy: "फर्ममार्फत पठाइएको व्यक्तिगत जानकारी नाम परामर्श सेवाको लागि मात्र प्रयोग गरिन्छ",
  contact_error: "पठाउन असफल भयो। कृपया पछि फेरि प्रयास गर्नुहोस् वा इमेलमार्फत सिधै सम्पर्क गर्नुहोस्",
  contact_err_name: "कृपया आफ्नो पूरा नाम लेख्नुहोस्",
  contact_err_email_required: "कृपया आफ्नो इमेल ठेगाना लेख्नुहोस्",
  contact_err_email_invalid: "कृपया सही इमेल ठेगाना लेख्नुहोस्",
  contact_err_service: "कृपया सेवा छान्नुहोस्",
  contact_err_message_required: "कृपया सन्देश लेख्नुहोस्",
  contact_err_message_limit: "सन्देश ५०० अक्षरभन्दा बढी हुनु हुँदैन",
  contact_thanks_title: "सन्देश पठाइयो",
  contact_thanks_desc: "सम्पर्क गर्नुभएकोमा धन्यवाद\nतपाईंको सन्देश समीक्षा गरेपछि, हामी <strong>२-३ कार्य दिनभित्र</strong> जवाफ दिनेछौं\nकृपया प्रतीक्षा गर्नुहोस्",
  contact_thanks_check1: "पुष्टि इमेल जाँच गर्नुहोस्",
  contact_thanks_check2: "स्प्याम फोल्डर पनि जाँच गर्नुहोस्",
  contact_thanks_check3: "२-३ कार्य दिनभित्र जवाफको प्रतीक्षा गर्नुहोस्",
  contact_thanks_another: "अर्को सन्देश पठाउनुहोस्",

  // Footer
  footer_subtitle: "नाम परामर्श · ओकिनावा",
  footer_title: "टेन्टेन अंकलको कार्यालय",
  footer_desc: "ओकिनावाबाट सम्पूर्ण देशमा, ५० वर्षभन्दा बढी अनुभव भएका नाम परामर्श विशेषज्ञले तपाईंको नाममा लुकेको भाग्यलाई ध्यानपूर्वक पढ्छन्",
  footer_contact_title: "सम्पर्क जानकारी",
  footer_address_label: "ठेगाना",
  footer_address_value: "तोचिगी, जापान\n(अनलाइन · सम्पूर्ण देशमा सेवा)",
  footer_email_label: "इमेल",
  footer_hours_label: "कार्य समय",
  footer_hours_value: "सोम–शुक्र ९:००–१८:००\n(शनि/आइत/सार्वजनिक बिदा बन्द)",
  footer_nav_title: "नेभिगेसन",
  footer_copyright: "© २०२५ टेन्टेन अंकलको कार्यालय। सर्वाधिकार सुरक्षित",
  footer_privacy: "गोपनीयता नीति",
  footer_law: "विशेष व्यापार कानून",
  footer_sitemap: "साइटम्याप",
};

export default ne;
